// Backend error `detail` strings are localised (the API honours Accept-Language),
// so we cannot compare against a single hard-coded sentence. Match the known
// wordings first, then fall back to a keyword heuristic per language.
const CLINIC_NOT_FOUND_MESSAGES = [
  'ไม่พบเบอร์โทรของคุณในระบบคลีนิค กรุณาลงทะเบียนที่คลีนิคก่อน',
]

const normalize = (value) => String(value ?? '').replace(/\s+/g, ' ').trim()

/**
 * True when the API is telling us the phone number has no customer record at the
 * clinic yet. Callers use this to route the user into the sync/registration flow
 * instead of surfacing the raw message.
 */
const isClinicCustomerNotFound = (detail) => {
  const message = normalize(detail)
  if (!message) return false
  if (CLINIC_NOT_FOUND_MESSAGES.some(known => normalize(known) === message)) return true

  // Thai: "ไม่พบเบอร์โทร ... คลีนิค" (the API spells it คลีนิค / คลินิก interchangeably)
  const isThaiMatch = message.includes('ไม่พบ')
    && message.includes('เบอร์โทร')
    && (message.includes('คลีนิค') || message.includes('คลินิก'))
  if (isThaiMatch) return true

  // English: "Your phone number was not found in the clinic system..."
  const lowered = message.toLowerCase()
  return lowered.includes('clinic')
    && (lowered.includes('phone') || lowered.includes('number'))
    && (lowered.includes('not found') || lowered.includes('not registered'))
}

export { isClinicCustomerNotFound }
export default isClinicCustomerNotFound
